<template>
    <ul class="attachment-list" v-if="hasPhotoAttachment(blockoutDay)">
        <li v-for="value in getPhotoUrls(blockoutDay.attachments)" :key="value.photoUrl">
            <a @click="viewPhoto(blockoutDay.attachments.photoUrls, value)">
                <md-icon>
                    image
                </md-icon>

                <md-tooltip md-direction="top">
                    {{ value.photoName }}
                </md-tooltip>
            </a>
        </li>
    </ul>
</template>

<script>
import PhotoPreviewModal from '@/components/PhotoPreviewModal';

export default {
    name: 'BlockoutDaysImage',
    props: {
        blockoutDay: {
            type: Object,
            default: () => {},
            required: true
        },
        hasPhotoAttachment: {
            type: Function,
            required: true
        }
    },
    methods: {
        getPhotoUrls(attachments) {
            return attachments.flatMap((att) => att.photoUrls || []);
        },
        viewPhoto(photos, selected) {
            this.$modal
                .show(PhotoPreviewModal, {
                    photos,
                    selectedPhoto: selected
                })
                .then((response) => {
                    if (response && response.toLowerCase() === 'ok') {
                        this.$modal.hide();
                    }
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.attachment-list {
    list-style: none;
    padding: 0;
    margin: 0;

    display: flex;
    align-items: center;
    gap: 3px;
    flex-wrap: wrap;

    a {
        cursor: pointer;
        color: black;
        font-size: 13px;
    }
}
</style>
